import { render, staticRenderFns } from "./selectcomponent.vue?vue&type=template&id=1f8d427c&scoped=true&"
import script from "./selectcomponent.vue?vue&type=script&lang=js&"
export * from "./selectcomponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d427c",
  null
  
)

export default component.exports